import { Document, Page, View, Font, pdf } from '@react-pdf/renderer';
import { saveAs } from 'file-saver';
import { CaseDetailsModel } from '../../../lib/models/CaseDetailsModel';
import { AuditHistoryModel } from '../../../lib/models/AuditHistoryModel';
import { CaseMessageModel } from '../../../lib/models/CaseMessageModel';
import PdfHeader from './PdfHeader';
import PdfGeneralInfo from './PdfGeneralInfo';
import PdfClinicalReviews from './PdfClinicalReviews';
import PdfCaseMessages from './PdfCaseMessages';
import PdfHistory from './PdfHistory';

Font.register({
    family: 'Open Sans',
    fonts: [
        { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-regular.ttf' },
        {
            src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-600.ttf',
            fontWeight: 600
        }
    ]
});

export type PdfDocumentProps = {
    caseDetails: CaseDetailsModel | null;
    auditHistory?: AuditHistoryModel[];
    caseMessages?: CaseMessageModel[];
};

const PdfDocument = ({
    caseDetails: data,
    auditHistory: history,
    caseMessages: messages
}: PdfDocumentProps) => {
    return (
        <Document style={{ fontFamily: 'Open Sans', fontSize: 13 }}>
            <Page size={'A4'}>
                <View
                    style={{
                        width: '100%',
                        marginHorizontal: 'auto'
                    }}>
                    {data && (
                        <>
                            <PdfHeader caseDetails={data} />
                            <PdfGeneralInfo caseDetails={data} />
                            <PdfClinicalReviews caseDetails={data} />
                        </>
                    )}
                    <PdfCaseMessages caseMessages={messages} />
                    <PdfHistory auditHistory={history} />
                </View>
            </Page>
        </Document>
    );
};

const downloadAuditPagePdf = async ({
    caseDetails,
    auditHistory,
    caseMessages
}: PdfDocumentProps) => {
    const pdfObj = pdf(
        <PdfDocument
            caseDetails={caseDetails}
            auditHistory={auditHistory}
            caseMessages={caseMessages}
        />
    );
    const pdfBlob = await pdfObj.toBlob();
    saveAs(pdfBlob, `${caseDetails?.caseNumber.trim()}_${caseDetails?.caseStage.trim()}`);
};

export { downloadAuditPagePdf, PdfDocument };
